<form [formGroup]="destinataireform" (ngSubmit)="onSubmit()">
  <fieldset>
    <legend class="custom-legend">Destinataire de la demande</legend>

    <div class="column">
      @if (showDestinataireResponsableField) {
        <div class="col-6" id="destinataireResponsableField">
          <!-- <div class="row"> -->
          <label for="destinataireResponsable" class="label col-6 col-form-label"> Chefs de service *</label>
          <div class="form-text mb-1">Sélectionnez destinataire (service: Chef de service).</div>
          <mat-form-field class="w-100">
            <mat-select
              aria-label="Nom Prénom"
              name="destinataireResponsable"
              formControlName="destinataireResponsable"
              [(ngModel)]="val_ft_destinataireResponsable"
              >
              @for (responsable of filteredOptionsResponsable; track responsable) {
                <mat-option [value]="responsable">
                  {{ responsable.nom }} {{ responsable.prenom }}
                </mat-option>
              }
            </mat-select>
            @if (
              destinataireform.get('destinataireResponsable')?.hasError('required') &&
              destinataireform.get('destinataireResponsable')?.touched
              ) {
              <mat-error
                >
                Ce champ est obligatoire.
              </mat-error>
            }
          </mat-form-field>
        <!-- </div> -->
      </div>
    }
    @if (showDestinataireDirecteurField) {
      <div class="col-6" id="destinataireValidationField">
        <!-- <div class="row"> -->
        <label for="destinataireChargeGpeec" class="label col-6 col-form-label"> Directeurs *</label>
        <div class="form-text mb-1">Sélectionnez destinataire (service: Directeurs service).</div>
        <mat-form-field class="w-100">
          <mat-select
            aria-label="Nom Prénom"
            name="destinataireValidationDirecteur"
            formControlName="destinataireValidationDirecteur"
            [(ngModel)]="val_ft_destinataireValidation"
            >
            @for (directeur of filteredOptionsDirecteur; track directeur) {
              <mat-option [value]="directeur">
                {{ directeur.nom }} {{ directeur.prenom }}
              </mat-option>
            }
          </mat-select>
          @if (
            destinataireform.get('destinataireValidationDirecteur')?.hasError('required') &&
            destinataireform.get('destinataireValidationDirecteur')?.touched
            ) {
            <mat-error
              >
              Ce champ est obligatoire.
            </mat-error>
          }
        </mat-form-field>
      <!-- </div> -->
    </div>
  }
  @if (showDestinataireGpeecField) {
    <div class="col-6" id="destinataireGpeecField">
      <!-- <div class="row"> -->
      <label for="destinataireDrh" class="label col-6 col-form-label"> {{ libelleGpeecListe }} *</label>
      <div class="form-text mb-1">Sélectionnez {{ libelleGpeecListe }}.</div>
      <mat-form-field class="w-100">
        <mat-select
          aria-label="Nom Prénom"
          name="destinataireChargeGpeec"
          formControlName="destinataireChargeGpeec"
          [(ngModel)]="val_ft_destinataireGpeec"
          >
          @for (option of filteredOptionsGpeec; track option) {
            <mat-option [value]="option"> {{ option.nom }} {{ option.prenom }} </mat-option>
          }
        </mat-select>
        @if (
          destinataireform.get('destinataireChargeGpeec')?.hasError('required') &&
          destinataireform.get('destinataireChargeGpeec')?.touched
          ) {
          <mat-error
            >
            Ce champ est obligatoire.
          </mat-error>
        }
      </mat-form-field>
    <!-- </div> -->
  </div>
}

@if (showDestinataireDrhField) {
  <div class="col-6" id="destinataireDrhField">
    <!-- <div class="row"> -->
    <label for="destinataireValidationDirecteur" class="form-label" for="type" class="label col-6 col-form-label"> DRH *</label>
    <div class="form-text mb-1">Sélectionnez destinataire (service: DRH).</div>
    <mat-form-field class="w-100">
      <mat-select aria-label="Nom Prénom" name="destinataireDrh" formControlName="destinataireDrh" [(ngModel)]="val_ft_destinataireDrh">
        @for (drh of filteredOptionsDrh; track drh) {
          <mat-option [value]="drh"> {{ drh.nom }} {{ drh.prenom }} </mat-option>
        }
      </mat-select>
      @if (destinataireform.get('destinataireDrh')?.hasError('required') && destinataireform.get('destinataireDrh')?.touched) {
        <mat-error
          >
          Ce champ est obligatoire.
        </mat-error>
      }
    </mat-form-field>
  <!-- </div> -->
</div>
}
@if (showDestinataireDgField) {
  <div class="col-6" id="destinataireDgField">
    <!-- <div class="row"> -->
    <label for="destinataireDg" class="label col-6 col-form-label"> DG du pôle *</label>
    <div class="form-text mb-1">Sélectionnez destinataire DG (service: DG Administrative).</div>
    <mat-form-field class="w-100">
      <mat-select aria-label="Nom Prénom" name="destinataireDg" formControlName="destinataireDg" [(ngModel)]="val_ft_destinataireDg">
        @for (dg of filteredOptionsDg; track dg) {
          <mat-option [value]="dg"> {{ dg.nom }} {{ dg.prenom }} </mat-option>
        }
      </mat-select>
      @if (destinataireform.get('destinataireDg')?.hasError('required') && destinataireform.get('destinataireDg')?.touched) {
        <mat-error
          >
          Ce champ est obligatoire.
        </mat-error>
      }
    </mat-form-field>
  <!-- </div> -->
</div>
}
@if (showDestinataireDgsField) {
  <div class="col-6" id="destinataireDgsField">
    <!-- <div class="row"> -->
    <label for="destinataireDgs" class="label col-6 col-form-label"> DGS *</label>
    <div class="form-text mb-1">Sélectionnez destinataire DGS.</div>
    <mat-form-field class="w-100">
      <mat-select aria-label="Nom Prénom" name="destinataireDgs" formControlName="destinataireDgs" [(ngModel)]="val_ft_destinataireDgs">
        @for (dgs of filteredOptionsDgs; track dgs) {
          <mat-option [value]="dgs"> {{ dgs.nom }} {{ dgs.prenom }} </mat-option>
        }
      </mat-select>
      @if (destinataireform.get('destinataireDgs')?.hasError('required') && destinataireform.get('destinataireDgs')?.touched) {
        <mat-error
          >
          Ce champ est obligatoire.
        </mat-error>
      }
    </mat-form-field>
  <!-- </div> -->
</div>
}
@if (showDestinataireArchivageRhField) {
  <div class="col-6" id="destinataireArchivageRhField">
    <!-- <div class="row"> -->
    <label for="destinataireArchivageRh" class="label col-6 col-form-label"> Archivage RH *</label>
    <div class="form-text mb-1">Sélectionnez destinataire Archivage RH.</div>
    <mat-form-field class="w-100">
      <mat-select
        aria-label="Nom Prénom"
        name="destinataireArchivageRh"
        formControlName="destinataireArchivageRh"
        [(ngModel)]="val_ft_destinataireArchivageRh"
        >
        @for (archivageRh of filteredOptionsArchivageRh; track archivageRh) {
          <mat-option [value]="archivageRh">
            {{ archivageRh.nom }} {{ archivageRh.prenom }}
          </mat-option>
        }
      </mat-select>
      @if (
        destinataireform.get('destinataireArchivageRh')?.hasError('required') &&
        destinataireform.get('destinataireArchivageRh')?.touched
        ) {
        <mat-error
          >
          Ce champ est obligatoire.
        </mat-error>
      }
    </mat-form-field>
  <!-- </div> -->
</div>
}
</div>
</fieldset>
<div class="button-group">
  <button mat-stroked-button type="button" (click)="onReset()"><mat-icon>autorenew</mat-icon>Réinitialiser</button>
  <button mat-stroked-button type="button" matStepperPrevious><mat-icon>undo</mat-icon>Précédent</button>
  <button mat-flat-button color="primary" type="submit" (click)="onSubmit()" [disabled]="!destinataireform.valid">
    <mat-icon>picture_as_pdf</mat-icon>Générer
  </button>
</div>
</form>
